import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID; // e.g. G-XXXXXXX

function getOrCreateSessionId() {
  try {
    let sid = localStorage.getItem("pandax_sid");
    if (!sid) {
      sid = crypto.randomUUID ? crypto.randomUUID() : `s_${Math.random().toString(36).slice(2)}${Date.now()}`;
      localStorage.setItem("pandax_sid", sid);
    }
    return sid;
  } catch {
    return `anon_${Date.now()}`;
  }
}

// Inject the GA4 gtag script once, only if REACT_APP_GA_MEASUREMENT_ID is set.
let gaLoaded = false;
function loadGA() {
  if (gaLoaded || !GA_ID) return;
  gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false }); // we send manually per route
}

let pingTimer = null;

/**
 * Fires a pageview to /api/analytics/track on every route change,
 * and also to Google Analytics (if REACT_APP_GA_MEASUREMENT_ID is set).
 * Additionally sends a heartbeat every 60s so the "online now" counter stays fresh.
 */
export default function PageviewTracker() {
  const loc = useLocation();

  useEffect(() => { loadGA(); }, []);

  useEffect(() => {
    const sessionId = getOrCreateSessionId();
    const path = loc.pathname + loc.search;

    // GA4
    if (window.gtag && GA_ID) {
      window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
      });
    }

    // Built-in
    axios.post(
      `${API_URL}/api/analytics/track`,
      { path, referrer: document.referrer || null, session_id: sessionId },
      { withCredentials: true },
    ).catch(() => { /* silent */ });

    // Heartbeat: ping every 60s to keep this session in the "online now" bucket.
    if (pingTimer) clearInterval(pingTimer);
    pingTimer = setInterval(() => {
      axios.post(
        `${API_URL}/api/analytics/track`,
        { path, referrer: null, session_id: sessionId },
        { withCredentials: true },
      ).catch(() => {});
    }, 60_000);

    return () => { if (pingTimer) { clearInterval(pingTimer); pingTimer = null; } };
  }, [loc.pathname, loc.search]);

  return null;
}
